/* Milo Pad LP — port do custom_lp.js da máquina (buy box por VARIANTE, drawer Shrine). */

function VanillaCounter() {
  document.querySelectorAll('[data-vanilla-counter]').forEach((i) => {
    let start = parseInt(i.getAttribute('data-start-at')) || 0,
      end = parseInt(i.getAttribute('data-end-at')) || 0,
      delay = parseInt(i.getAttribute('data-delay')) || 0,
      time = parseInt(i.getAttribute('data-time')) || 1e3,
      counter = start,
      stepTime = Math.abs(Math.floor(time / (end - start)));
    i.innerHTML = counter;
    setTimeout(() => {
      let interval = setInterval(() => {
        counter += end > start ? 1 : -1;
        i.innerHTML = counter;
        if (counter == end) clearInterval(interval);
      }, stepTime);
    }, delay);
  });
}

jQuery(function ($) {
  /* tira o sticky do .milo-lp: ancestral com transform prende position:fixed */
  (function () {
    const cb = document.getElementById('call-btn');
    if (cb && cb.parentElement !== document.body) document.body.appendChild(cb);
  })();

  /* o wrapper sticky-header do Shrine colapsa (h=1) e o header pinta por cima do topo do main —
     empurra a LP pela altura real do header pra faixa do flash sale aparecer inteira */
  (function () {
    const hd = document.querySelector('header.header');
    const lp = document.querySelector('.milo-lp');
    const sh = document.querySelector('sticky-header');
    const apply = () => {
      if (!hd || !lp) return;
      lp.style.paddingTop = '0px';
      const overlap = hd.getBoundingClientRect().bottom - lp.getBoundingClientRect().top;
      if (overlap > 4 && window.scrollY < 5) lp.style.paddingTop = Math.round(overlap) + 'px';
    };
    apply();
    window.addEventListener('resize', apply);
  })();
  /* mascote nas divisórias: entra/sai conforme o scroll */
  (function () {
    const els = document.querySelectorAll('.mlp-milo');
    if (!els.length || !('IntersectionObserver' in window)) { els.forEach(e => e.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => en.target.classList.toggle('is-in', en.isIntersecting));
    }, { threshold: 0.35 });
    els.forEach((e) => io.observe(e));
  })();

  /* barras de progresso (Research Backed Results) */
  var triggered = false;
  $(window).on('scroll', function () {
    if ($('.running-bar').length) {
      var sectionTop = $('.running-bar').offset().top - 600,
        scrollTop = $(window).scrollTop();
      if (scrollTop > sectionTop && !triggered) {
        triggered = true;
        $('.sec8_left_inner_row').each(function () {
          var value = $(this).attr('data-wdth');
          $(this).find('.s8_progress_inr').css('width', value + '%');
        });
        VanillaCounter();
      }
    }
  });

  /* accordions */
  $('.question_box .accordion').click(function () {
    var q = $(this), a = $(this).next('.acdn_content'), idx = $('.acdn_content').index(a);
    $('.acdn_content').each(function (i, el) {
      if (i != idx && $(el).is(':visible')) $(el).slideUp(500, function () { $(el).prev('.accordion').removeClass('accordion_open'); });
    });
    if (a.is(':visible')) a.stop().slideUp(500, function () { q.removeClass('accordion_open'); });
    else { q.addClass('accordion_open'); a.stop().slideDown(500); }
  });
  $('.hero_question_heading').click(function () {
    var q = $(this), a = $(this).next('.hero_question_content'), idx = $('.hero_question_content').index(a);
    $('.hero_question_content').each(function (i, el) {
      if (i != idx && $(el).is(':visible')) $(el).slideUp(500, function () { $(el).prev('.hero_question_heading').removeClass('hero_question_heading_open'); });
    });
    if (a.is(':visible')) a.stop().slideUp(500, function () { q.removeClass('hero_question_heading_open'); });
    else { q.addClass('hero_question_heading_open'); a.stop().slideDown(500); }
  });

  /* drawer do tema (Shrine) — mesmo padrão da máquina */
  function updateCartDrawer() {
    const cartUrl = `${window.Shopify.routes.root}cart?section_id=cart-drawer`;
    return fetch(cartUrl)
      .then((res) => res.text())
      .then((html) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const newCartDrawer = tempDiv.querySelector('cart-drawer');
        if (newCartDrawer) {
          const existing = document.querySelector('cart-drawer');
          if (existing) existing.replaceWith(newCartDrawer);
          else document.body.appendChild(newCartDrawer);
          newCartDrawer.classList.remove('is-empty');
          newCartDrawer.classList.add('animate', 'active');
          document.body.classList.add('cart-drawer-open');
        }
        const newBubble = tempDiv.querySelector('#cart-icon-bubble') || tempDiv.querySelector('.cart-count-bubble');
        const oldBubble = document.querySelector('#cart-icon-bubble');
        if (newBubble && oldBubble) oldBubble.innerHTML = newBubble.innerHTML;
      })
      .catch((err) => console.error('Cart fetch error:', err));
  }

  /* buy box: tier = variante */
  function activeRow() { return document.querySelector('.butOption_row.active'); }
  function syncButton() {
    const row = activeRow();
    if (!row) return;
    const offer = row.getAttribute('offer-price') || '';
    const total = row.getAttribute('total-price') || '';
    document.querySelectorAll('.btn_regular').forEach((el) => {
      el.textContent = total;
      el.style.display = total ? '' : 'none';
    });
    document.querySelectorAll('.btn_offer_price').forEach((el) => { el.textContent = offer; });
    const vid = row.getAttribute('data-vid');
    const hid = document.getElementById('selectedVariantId');
    if (hid && vid) hid.value = vid;
  }
  $('.butOption_row').on('click', function () {
    $('.butOption_row').removeClass('active');
    $(this).addClass('active');
    $(this).find('input[type="radio"]').prop('checked', true);
    syncButton();
  });
  syncButton();

  /* hover carimbo (sombra offset da loja) — só ponteiro fino */
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    $(document).on('mouseenter', '.milo-lp .common_button', function () { $(this).addClass('is-hover'); });
    $(document).on('mouseleave', '.milo-lp .common_button', function () { $(this).removeClass('is-hover'); });
  }

  /* ATC (delegado: buy box + sticky) */
  $(document).on('click', '.common_button.atc', function (e) {
    e.preventDefault();
    const $btn = $(this);
    if ($btn.hasClass('is-loading')) return;
    const variantId = $('#selectedVariantId').val();
    if (!variantId) return;
    $btn.addClass('is-loading').attr('aria-busy', 'true');
    $.post('/cart/add.js', { items: [{ id: variantId, quantity: 1 }] }, function () {
      Promise.resolve(updateCartDrawer()).finally(function () {
        $btn.removeClass('is-loading').removeAttr('aria-busy');
      });
    }, 'json').fail(function (err) {
      console.error('Cart error:', err);
      $btn.removeClass('is-loading').removeAttr('aria-busy');
    });
  });

  /* sliders */
  var numSlick = 0;
  $('.hero_image_slider').each(function () {
    numSlick++;
    $(this).slick({ slidesToShow: 1, slidesToScroll: 1, arrows: false, fade: false, autoplay: false, dots: false, asNavFor: '.hero_thumb_slider.slider-' + 1 });
  });
  $('.hero_thumb_slider').each(function () {
    $(this).slick({ vertical: false, slidesToShow: 5, slidesToScroll: 1, asNavFor: '.hero_image_slider.slider-' + 1, dots: false, focusOnSelect: true, arrows: false, adaptiveHeight: true, infinite: true });
  });
  if ($('.petOwner_review_slider').length) {
    $('.petOwner_review_slider').slick({ dots: true, slidesToShow: 4, slidesToScroll: 1, speed: 700, infinite: true, variableWidth: true, centerMode: false, arrows: false });
  }

  /* countdown do top strip */
  if (document.getElementById('hours')) {
    /* 29/set: ciclo global de 3 dias (mesmo prazo p/ todos); ao acabar, abre novo ciclo de 3 dias */
    const CYCLE = 3 * 24 * 3600 * 1000, EPOCH = Date.UTC(2026, 8, 29, 4, 0, 0); /* 29/set 00:00 ET */
    let endAt = EPOCH + Math.ceil((Date.now() - EPOCH + 1) / CYCLE) * CYCLE;
    let totalSeconds = Math.max(0, Math.floor((endAt - Date.now()) / 1000));
    const upd = () => {
      let h = Math.floor(totalSeconds / 3600), m = Math.floor((totalSeconds % 3600) / 60), s = totalSeconds % 60;
      document.getElementById('hours').textContent = String(h).padStart(2, '0');
      document.getElementById('minutes').textContent = String(m).padStart(2, '0');
      document.getElementById('seconds').textContent = String(s).padStart(2, '0');
      if (totalSeconds > 0) totalSeconds--; else { endAt += CYCLE; totalSeconds = Math.floor((endAt - Date.now()) / 1000); }
    };
    upd();
    const t = setInterval(upd, 1000);
  }

  /* CTAs → leva o Add to Cart pra tela (não só o título dos packs) */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.common_button');
    if (btn && !btn.classList.contains('atc')) {
      e.preventDefault();
      const atc = document.querySelector('.package_box .common_button.atc');
      const box = document.querySelector('#package_box_bundle');
      const target = atc || box;
      if (!target) return;
      const y = atc
        ? atc.getBoundingClientRect().top + window.pageYOffset - (window.innerHeight - 200)
        : box.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }
  });

  /* sticky: Add to Cart até a oferta; some em cima do buy box; Claim depois que passou */
  function setStickyMode(mode) {
    const stickyBtn = document.querySelector('#call-btn .common_button');
    const label = stickyBtn && stickyBtn.querySelector('.btn_cart_text');
    if (!stickyBtn) return;
    if (mode === 'atc') {
      stickyBtn.classList.add('atc');
      stickyBtn.classList.remove('btn_scorall', 'pulse');
      stickyBtn.setAttribute('href', 'javascript:void(0)');
      if (label) label.textContent = 'Add To Cart';
    } else {
      stickyBtn.classList.remove('atc', 'is-loading');
      stickyBtn.classList.add('btn_scorall', 'pulse');
      stickyBtn.setAttribute('href', '#package_box_bundle');
      if (label) label.textContent = 'Get The Family Pack';
    }
  }
  function syncStickyCta() {
    const bar = document.getElementById('call-btn');
    const atc = document.querySelector('.package_box .common_button.atc');
    if (!bar) return;
    if (!atc) { bar.classList.add('is-off'); return; }
    const r = atc.getBoundingClientRect();
    const inView = r.top < window.innerHeight - 16 && r.bottom > 72;
    if (inView) {
      bar.classList.add('is-off');
      return;
    }
    bar.classList.remove('is-off');
    setStickyMode(r.top >= window.innerHeight - 16 ? 'atc' : 'claim');
  }
  syncStickyCta();
  window.addEventListener('scroll', syncStickyCta, { passive: true });
  window.addEventListener('resize', syncStickyCta);
});
